<template>
  <div class="widget">
    <h3>岗位
      <router-link to="/job" class="more">更多&gt;</router-link>
    </h3>
    <ul>
      <li v-for="item in joblist" :key="item.job_id">
        <router-link :to="`/jobcontent/${item.job_id}`" class="w-title">
          {{ item.job_name }} <span class="w-price">{{ item.job_salary }}</span>
        </router-link>
      </li>
    </ul>
    <h3 style="margin-top: 16px;">公司</h3>
    <ul>
      <li v-for="item in companylist" :key="item.company_id">
        <router-link :to="`/companycontent/${item.company_id}`" class="w-title">{{ item.company_name }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { getJobList, getCompanyList } from '@/api'

export default {
  name: 'JobWidget',
  data() {
    return { joblist: [], companylist: [] }
  },
  created() {
    getJobList({ page: 1, pagesize: 5 }).then((res) => {
      this.joblist = res.data || []
    })
    getCompanyList({ page: 1, pagesize: 5 }).then((res) => {
      this.companylist = res.data || []
    })
  }
}
</script>
